export type SubscribeProductMessages = {
  safeBuyLabel: string;
  signatureLabel: string;
  totalLabel: string;
  chargedEveryMonthLabel: string;
  additionalFeeLabel: string;
  perOrderLabel: string;
  additionalFeesLabel: string;
  feePerOrderText: string;
  feePerConversationText: string;
};

export const SUBSCRIBE_PRODUCT_MESSAGES: SubscribeProductMessages = {
  safeBuyLabel: "Compra segura",
  signatureLabel: "Assinatura:",
  totalLabel: "Total:",
  chargedEveryMonthLabel: "Cobrada mensalmente de forma automática",
  additionalFeeLabel: "Taxa adicional:",
  perOrderLabel: "por pedido",
  additionalFeesLabel: "Taxas adicionais:",
  feePerOrderText: "por pedido",
  feePerConversationText: "por conversa",
};
